export default __webpack_public_path__ + "static/icon-12-3-c19ccd5a7b2fdd2e28a30e1108df18d9.png";